import { log } from '@insticator/insticator-ui'; // iui-utils

export const formDataBlob = (selectedEmbedData, contents, addons, updatedContents, executorUUID, currentStepPage) => {
    log('>>>>>>>> formDataBlob <<<<<<<<', 'selectedEmbedData:', selectedEmbedData, 'contents:', contents, 'executorUUID:', executorUUID)
    const ads = selectedEmbedData.ads;
    const adsLocation = selectedEmbedData.location;
    const isNewEmbed = !selectedEmbedData.embedUUID;
    const data = {
        embed: {
            contentOrder: selectedEmbedData.contentOrder.toUpperCase(),
            embedName: selectedEmbedData.embedName,
            embedPosition: selectedEmbedData.location === 'in-content' ? 'IN_CONTENT' : 'RAIL',
            webAdDisplayMode: _getAdsPosition(ads, adsLocation, false),
            mobileAdDisplayMode: _getAdsPosition(ads, adsLocation, true),
            showVideoAdForDesktop: selectedEmbedData.ads.video.desktop,
            showVideoAdForMobile: selectedEmbedData.ads.video.mobile,
            partnerLogoUrl: selectedEmbedData.partnerLogo.src,
            showInsticatorBranding: selectedEmbedData.showInsticatorBranding,
            logoClickThroughUrl: selectedEmbedData.partnerLogo.url,
            brandColorCode: selectedEmbedData.brandColor,
            showMarketResearch: false, //selectedEmbedData.addons.marketResearch,
            showProfilingQuestions: selectedEmbedData.revenue.profilingQuestions,
            showRewards: false,
            showPartnerLogo: selectedEmbedData.showPartnerLogo,
            showUserDataCollection: selectedEmbedData.showUserDataCollection,
            attachedLabelUUIDs: selectedEmbedData.attachedLabelUUIDs,
            newLabelNames: []
        },
        contents: {
            pages: _getPages(contents, isNewEmbed, updatedContents),
            addOns: currentStepPage === 'add_ons' ? formAddOnSaveData(addons) : null
        }
    };
    if(isNewEmbed) data['createdBy'] = executorUUID;
    if(!!currentStepPage) data['embedWorkflowStep'] = currentStepPage.toUpperCase();
    log('>>>>>>>> formDataBlob <<<<<<<<', 'BLOB', data);
    return data;
};

const formAddOnSaveData = addOnData => {
    let addons = {};
    let dataPresent = false;

    if(!!addOnData.userDataCollection.dataPresent){
        dataPresent = true;
        addons.userDataCollection = {
            contentUUID: addOnData.userDataCollection.contentUUID,
            queuePosition: addOnData.userDataCollection.queuePosition.value,
            publisherName: addOnData.userDataCollection.publisherName.value,
            publisherPrivacyPolicyURL: addOnData.userDataCollection.publisherPrivacyPolicyURL.value,
            backgroundColor: addOnData.userDataCollection.backgroundColor.value,
            backgroundImageURL: addOnData.userDataCollection.backgroundImageURL,
            headline: addOnData.userDataCollection.headline.value,
            body: addOnData.userDataCollection.body.value
        }
    }

    return dataPresent ? addons : null;
};

// backgroundColor: {value: "rgba(179, 34, 34, 0.8)", valid: true}
// backgroundImageURL: "https://d1mxva141a8fyb.cloudfront.net/client_add_ones_images/user_data_collection/86dd03a1-053f-4e3e-90e7-389070a0c62c/65ef9be5-8d00-4521-a830-16db43fe3f03"
// body: {value: "", valid: null}
// contentUUID: null
// headline: {value: "", valid: null}
// publisherName: {value: "jon", valid: null}
// publisherPrivacyPolicyURL: {value: "link", valid: null}
// queuePosition: {value: 1, valid: true}

const _getPages = (contents, isNewEmbed, updatedContents) => {
    const newNoContentEmbed = isNewEmbed && Object.keys(contents).length === 0;
    const noContentsUpdated = !isNewEmbed && updatedContents.length === 0;
    if (newNoContentEmbed || noContentsUpdated) return [];

    const pages = [];
    const contentIds = isNewEmbed ? Object.keys(contents) : updatedContents;
    for(let contentId of contentIds) {
        const contentDetail = (contents[contentId].contentType === "story") ? contents[contentId].story : contents[contentId].questionBased;
        pages.push({
            contentUUID: contentDetail.contentUUID,
            contentType: contents[contentId].contentType.toUpperCase(),
            contentLive: contents[contentId].contentLive,
            queuePosition: contents[contentId].queuePosition,
            contentProperties: getContentPropertiesByContentType(contents[contentId].contentType, contents[contentId])
        })
    }
    log('>>>>>>>> _getPages <<<<<<<<', 'PAGES', pages);
    return pages;
};

const getBackgroundProperties = content => {
    const uniqueueProps = content[content.contentType === 'story' ? 'story' : 'questionBased'];
    return {
        backgroundImageProvider: uniqueueProps.imageProvider,
        backgroundImageID: uniqueueProps.imageID,
        imageURL: (uniqueueProps.imageProvider === 'SHUTTERSTOCK' || uniqueueProps.imageProvider === 'UNSPLASH') ? null : content.imageURL,
        backgroundImageURL: uniqueueProps.backgroundImageURL,
        backgroundColor: uniqueueProps.backgroundColor
    }
};

const getContentPropertiesByContentType = (contentType, content) => {
    switch (contentType){
        case 'story':
            return { ...transpileStoryContent(content.story), ...getBackgroundProperties(content) };
        case 'quiz':
        case 'poll':
            return { ...transpileQuestionBasedContent(content, content.questionBased), ...getBackgroundProperties(content) };
                default:
            return null;
    }
};

const transpileStoryContent = (contentDetail) => ({
    title: contentDetail.title,
    ctaText: contentDetail.ctaText,
    storyURL: contentDetail.url
});

const transpileQuestionBasedContent = (content, contentDetail) => ({
    title: contentDetail.title,
    type: contentDetail.type.toUpperCase(),
    options: _getOptions(contentDetail.options, contentDetail.type, content.contentType)
});

const _getOptions = (options, questionType, contentType) => {
    log('>>>>>>>> _getOptions <<<<<<<<', 'options', options, 'questionType', questionType, 'contentType', contentType);
    const processedOptions = [];
    for (let optionId of Object.keys(options)) {
        processedOptions.push({
            optionUUID: options[optionId].optionUUID,
            text: _includesText(questionType) ? options[optionId].text : null,
            imageProvider: _includesImage(questionType) ? options[optionId].imageProvider : null,
            imageID: _includesImage(questionType) ? options[optionId].imageID : null,
            imageURL: _includesImage(questionType) ? (options[optionId].imageProvider === 'SHUTTERSTOCK' || options[optionId].imageProvider === 'UNSPLASH') ? null : options[optionId].imageURL : null,
            emoji: questionType === 'emoji' ? options[optionId].emoji : null,
            correctOption: contentType === 'quiz' ? options[optionId].correctOption : false,
            position: options[optionId].position
        })
    }
    log('>>>>>>>> _getOptions <<<<<<<<', 'PROCESSED OPTIONS', processedOptions);
    return processedOptions;
};

const _includesImage = questionType => ['image2', 'image1'].includes(questionType);

const _includesText = questionType => ['image1', 'text1', 'text2'].includes(questionType);

const _getAdsPosition = (ads, adsLocation, isMobile) => {
    log('>>>>>>>> _getAdsPosition <<<<<<<<', 'PROCESSED OPTIONS', 'ads', ads, 'adsLocation', adsLocation, 'isMobile', isMobile);
    const location = isMobile ? 'mobile' : 'desktop';
    const ad1 = ads[location].ad1;
    const ad2 = ads[location].ad2;
    const overlay = ads[location].overlay;
    const isRail = isMobile || adsLocation !== 'in-content';
    if (isRail && ad1 && !overlay && ad2) {
        return 'REGULAR';
    } else if (isRail && !ad1 && overlay && ad2) {
        return 'OVERLAY_TOP_AD';
    } else if (isRail && ad1 && overlay && !ad2) {
        return 'OVERLAY_BOTTOM_AD';
    } else if (!isRail && overlay) {
        return 'BOTH_OVERLAY_ADS';
    } else if (!isRail && ad1 && ad2) {
        return 'BOTH_BOTTOM_ADS';
    } else {
        return 'NONE';
    }
};


